import classNames from "classnames";
import React, { FC } from "react";

interface TreatmentsLocationsFilterItemProps {
  isChecked: boolean;
  bolderLabel?: boolean;
  onChange: () => void;
  label: string;
}

export const TreatmentsLocationsFilterItem: FC<TreatmentsLocationsFilterItemProps> = ({
  isChecked,
  bolderLabel,
  onChange,
  label,
}) => {
  return (
    <div className="form-check">
      <label
        className={classNames("form-check-label", { "fw-bolder": bolderLabel })}
      >
        <input
          type="checkbox"
          className="form-check-input form-check-input--light"
          checked={isChecked}
          onChange={onChange}
        />
        {label}
      </label>
    </div>
  );
};
